import { render, staticRenderFns } from "./WholesaleBillInfoV2.vue?vue&type=template&id=bd923754"
import script from "./WholesaleBillInfoV2.vue?vue&type=script&lang=js"
export * from "./WholesaleBillInfoV2.vue?vue&type=script&lang=js"
import style0 from "./WholesaleBillInfoV2.vue?vue&type=style&index=0&id=bd923754&prod&lang=css"
import style1 from "./WholesaleBillInfoV2.vue?vue&type=style&index=1&id=bd923754&prod&lang=scss"
import style2 from "./WholesaleBillInfoV2.vue?vue&type=style&index=2&id=bd923754&prod&lang=scss"
import style3 from "./WholesaleBillInfoV2.vue?vue&type=style&index=3&id=bd923754&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports